function upload(pdfFile, documentType) {
  return getPdf(pdfFile).then(pdf => ({
    name: pdfFile.name,
    file: pdf,
    type: documentType,
  }))
}

function getPdf(file) {
  return new Promise(resolve => {
    const fReader = new FileReader()
    let base64Pdf
    fReader.onload = fileLoadedEvent => {
      base64Pdf = fileLoadedEvent.target.result
      resolve(base64Pdf.split(',')[1])
    }
    fReader.readAsDataURL(file)
  })
}

export { upload }
